import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import contactData from "./contactData";

const footerData = {
  brand: {
    name: "Prini Crackers",
    description: "Quality fireworks from Sivakasi, delivered with care and tradition.",
  },
  contact: [
    {
      icon: <FaPhoneAlt />,
      label: "Phone",
      value: `+91 ${contactData.phoneNumber}`,
      href: `tel:+91${contactData.phoneNumber}`,
    },
    {
      icon: <FaEnvelope />,
      label: "Email",
      value: contactData.email,
      href: `mailto:${contactData.email}`,
    },
    {
      icon: <FaMapMarkerAlt />,
      value: "Our Location",
      href: "https://maps.app.goo.gl/fKe55HqnPiCE1FRe6",
    },
  ],
  quickLinks: [
    { name: "Home", to: "/" },
    { name: "About Us", to: "/about-us" },
    { name: "Products", to: "/products" },
    { name: "Offers", to: "/offers" },
    { name: "Safety Tips", to: "/safety-tips" },
    { name: "Contact", to: "/contact" },
    // { name: "Privacy Policy", to: "/privacy" },
    // { name: "Terms & Conditions", to: "/terms" },
  ],
  social: {
    instagram: `https://instagram.com/${contactData.instagram}`,
    facebook: `https://facebook.com/${contactData.facebook}`,
  },
};

export default footerData;
